class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this._countdownIntervals = [];
    this._boundClose = this.close.bind(this);
    this._boundUpdateBarHeight = this.updateBarHeight.bind(this);

    this.closeButton = this.querySelector("[data-close-button]");
    this.announcementBar = document.querySelector(".utility-bar");

    if(this.closeButton) {
      this.closeButton.addEventListener("click", this._boundClose);
    }
    window.addEventListener("resize", this._boundUpdateBarHeight);
  }

  connectedCallback() {
    this.checkClosedState();
    setTimeout(() => this.initCountdowns(), 0);

    if(document.readyState === 'complete') {
      this.updateBarHeight();
    } else {
      window.addEventListener('load', this._boundUpdateBarHeight);
    }
  }

  disconnectedCallback() {
    this.closeButton?.removeEventListener("click", this._boundClose);
    window.removeEventListener('load', this._boundUpdateBarHeight);
    window.removeEventListener('resize', this._boundUpdateBarHeight);
    this._countdownIntervals.forEach(clearInterval);
    this._countdownIntervals = [];
  }

  checkClosedState() {
    const isClosed = sessionStorage.getItem("announcementClosed");
    if (isClosed) {
      if(this.announcementBar) {
        this.announcementBar.classList.add('is-hidden');
      }
      document.documentElement.style.setProperty(
        "--announcement-bar-height",
        "0px"
      );
    }
  }

  close() {
    if(this.announcementBar) {
      this.announcementBar.classList.add('is-hidden');
    }
    document.documentElement.style.setProperty(
      "--announcement-bar-height",
      "0px"
    );
    sessionStorage.setItem("announcementClosed", "true");
  }

  updateBarHeight() {
    if(!this.announcementBar) return;
    const barHeight = this.announcementBar.offsetHeight + "px";
    document.documentElement.style.setProperty("--announcement-bar-height", barHeight);
  }

  initCountdowns() {
    this._countdownIntervals.forEach(clearInterval);
    this._countdownIntervals = [];

    const timers = this.querySelectorAll('[data-countdown-target]');
    if (!timers.length) return;

    const SECOND = 1000;
    const MINUTE = SECOND * 60;
    const HOUR = MINUTE * 60;
    const DAY = HOUR * 24;

    timers.forEach((timer) => {
      const targetDate = new Date(timer.dataset.countdownTarget).getTime();
      if (isNaN(targetDate)) return;

      const daysEl = timer.querySelector('[data-days]');
      const hoursEl = timer.querySelector('[data-hours]');
      const minutesEl = timer.querySelector('[data-minutes]');
      const secondsEl = timer.querySelector('[data-seconds]');
      const srEl = timer.parentElement.querySelector('[data-countdown-sr]');

      if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

      const update = () => {
        const distance = targetDate - Date.now();

        if (distance <= 0) {
          daysEl.textContent = '0';
          hoursEl.textContent = '0';
          minutesEl.textContent = '0';
          secondsEl.textContent = '0';
          if (srEl) srEl.textContent = '0 days, 0 hours, 0 minutes';
          clearInterval(intervalId);
          return;
        }

        const days = Math.floor(distance / DAY);
        const hours = Math.floor((distance % DAY) / HOUR);
        const minutes = Math.floor((distance % HOUR) / MINUTE);
        const seconds = Math.floor((distance % MINUTE) / SECOND);

        daysEl.textContent = days;
        hoursEl.textContent = hours;
        minutesEl.textContent = minutes;
        secondsEl.textContent = seconds;

        if (srEl && seconds === 0) {
          srEl.textContent = `${days} days, ${hours} hours, ${minutes} minutes`;
        }
      };

      update();
      const intervalId = setInterval(update, 1000);
      this._countdownIntervals.push(intervalId);
    });
  }
}

customElements.define("announcement-bar", AnnouncementBar);
